export const breakpoints = {
    sm: 0,
    md: 48, //768px
    lg: 75, //1200px
};
